import { Button } from "antd";

export default function PrimaryButton({lableclassName,disabled, style, onClick, label, icon, className }) {
  return <Button
  icon={icon}
  disabled={disabled}
  className={className}
    type="primary"
    htmlType="button"
    onClick={onClick}//() => { setOpenUpdate(true); setSelected(null); }}
    style={style}>
    <span className={lableclassName}>{label}</span>
  </Button>
}